import { BlueJApi } from '../../core/api/blue-j-api';
import { RequestWorkflowAccessPayload, WorkflowDefinitionResponse } from './types';

export class WorkflowsApi extends BlueJApi {
  private basePath = 'api'

  private _getWorkflowDefinitions = this.createFetch<null, WorkflowDefinitionResponse, void>(`${this.basePath}/workflows`, 'GET');
  private _abortWorkflow = this.createFetch<{ threadId: string; workflowRunId?: string }, void, void>(`${this.basePath}/abort-workflow`, 'POST');
  private _requestWorkflowAccess = this.createFetch<RequestWorkflowAccessPayload, void, void>(`${this.basePath}/request-workflow-access`, 'POST');
  private _runWorkflowVersion = this.createFetch<{ threadId: string; message: string }, { jobId: string }, { workflowId: string; version: number }>(
    params => `${this.basePath}/admin/workflows/${params.workflowId}/versions/${params.version}/run`,
    'POST'
  );
  private _rerunWorkflowVersion = this.createFetch<{ threadId: string; fromStepIndex: number; toStepIndex?: number }, { jobId: string }, { workflowId: string; version: number }>(
    params => `${this.basePath}/admin/workflows/${params.workflowId}/versions/${params.version}/rerun`,
    'POST'
  );
  private _runWorkflowDraft = this.createFetch<{ threadId: string; message: string }, { jobId: string }, { workflowId: string }>(
    params => `${this.basePath}/admin/workflows/${params.workflowId}/draft/run`,
    'POST'
  );
  private _rerunWorkflowDraft = this.createFetch<{ threadId: string; fromStepIndex: number; toStepIndex?: number }, { jobId: string }, { workflowId: string }>(
    params => `${this.basePath}/admin/workflows/${params.workflowId}/draft/rerun`,
    'POST'
  );
  private _getWorkflowVersions = this.createFetch<null, { versions: { version: number }[] }, { workflowId: string }>(
    params => `${this.basePath}/admin/workflows/${params.workflowId}`,
    'GET'
  );

  public async getWorkflowDefinitions() {
    return this._getWorkflowDefinitions().parsedResponse();
  }

  public async abortWorkflow(threadId: string, workflowRunId?: string): Promise<void> {
    return this._abortWorkflow({ threadId, workflowRunId }).parsedResponse();
  }

  public async requestWorkflowAccess(payload: RequestWorkflowAccessPayload): Promise<void> {
    return this._requestWorkflowAccess(payload).parsedResponse();
  }

  public async runWorkflowVersion(workflowId: string, version: number, payload: { threadId: string; message: string }): Promise<{ jobId: string }> {
    return this._runWorkflowVersion(payload, { workflowId, version }).parsedResponse();
  }

  public async runWorkflowDraft(workflowId: string, payload: { threadId: string; message: string }): Promise<{ jobId: string }> {
    return this._runWorkflowDraft(payload, { workflowId }).parsedResponse();
  }

  public async rerunWorkflowVersion(
    workflowId: string,
    version: number,
    payload: { threadId: string; fromStepIndex: number; toStepIndex?: number }
  ): Promise<{ jobId: string }> {
    return this._rerunWorkflowVersion(payload, { workflowId, version }).parsedResponse();
  }

  public async rerunWorkflowDraft(
    workflowId: string,
    payload: { threadId: string; fromStepIndex: number; toStepIndex?: number }
  ): Promise<{ jobId: string }> {
    return this._rerunWorkflowDraft(payload, { workflowId }).parsedResponse();
  }

  public async getWorkflowVersions(workflowId: string): Promise<{ versions: { version: number }[] }> {
    return this._getWorkflowVersions(null, { workflowId }).parsedResponse();
  }
}
